import { render, staticRenderFns } from "./VlastFooter.vue?vue&type=template&id=d9ec0806"
import script from "./VlastFooter.vue?vue&type=script&lang=js"
export * from "./VlastFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports